import Section1 from './Components/Header/section1';
import Section2 from './Components/cronometro-programacao/section2';
import Section3 from './Components/queroParticipar/section3';
import Section4 from './Components/sectionVideo/section4';
import Section5 from './Components/atracoes/section5';
import Section6 from './Components/mapaLocalizacao/section6';
import Section7 from './Components/footer/section7';
import Section8 from './Components/parceiros/section8'; 
import ScrollToTopButton from './Components/ScrollToTopButton/ScrollToTopButton';
import './styles/App.css';
import Section9 from './Components/mapaFeira/section9';
import Section10 from './Components/metasPremiadas/section10';


function App() {
  return (
    <div className="App">
      <div id="link1" >
        <Section1 />
      </div>
      <div id="link4">
        <Section4 />
      </div>     
      <div id="link2">
        <Section2 />
      </div>
       <div id="link9">
        <Section9 />
      </div>      



    <div id="link10">
        <Section10 />
      </div>


      <div id="link5">
        <Section5 />
      </div>



      <div id="link3">
        <Section6 />
      </div>
      <Section3 /> 
      <div id="link8">
        <Section8 />
      </div>
      <div id="link6"> 
        <Section7 />
      </div>
      <ScrollToTopButton />
    </div>
  );
}

export default App;
